const IV_LEN = 12;

async function deriveKey(secret: string) {
    const enc = new TextEncoder();
    const hash = await crypto.subtle.digest('SHA-256', enc.encode(secret));
    return crypto.subtle.importKey('raw', hash, { name: 'AES-GCM' }, false, [
        'encrypt',
        'decrypt',
    ]);
}

function base64UrlDecode(str: string) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    const binary = atob(str);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
}

async function decrypt(token: string, secret: string) {
    const key = await deriveKey(secret);
    const combined = base64UrlDecode(token);
    const iv = combined.slice(0, IV_LEN);
    const ciphertext = combined.slice(IV_LEN);

    const ptBuffer = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv },
        key,
        ciphertext
    );
    return new TextDecoder().decode(ptBuffer);
}

export async function decryptData(data: any, secret: string): Promise<any> {
    if (Array.isArray(data)) {
        return Promise.all(data.map((item) => decryptData(item, secret)));
    }

    if (data !== null && typeof data === 'object') {
        const entries = await Promise.all(
            Object.entries(data).map(async ([k, v]) => [
                await decrypt(k as string, secret),
                await decryptData(v, secret),
            ])
        );
        return Object.fromEntries(entries);
    }

    const decrypted = await decrypt(data, secret);
    return JSON.parse(decrypted);
}